export const zdbRouteNames = {
  userProfile: 'mijn-gegevens',
};
